import { render, staticRenderFns } from "./InfosetRemoveModal.vue?vue&type=template&id=253d8a50&scoped=true&"
import script from "./InfosetRemoveModal.vue?vue&type=script&lang=ts&"
export * from "./InfosetRemoveModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d8a50",
  null
  
)

export default component.exports